import {clsx} from 'clsx';
import React, {FC} from 'react';

import {hexToRGB, MOON_300} from '../../../../../common/css/globals.styles';
import {Icon, IconName} from '../../../../Icon';
import {TailwindContents} from '../../../../Tailwind';

export const SmallRefBox: FC<{
  iconName: IconName;
  text: string;
  iconOnly?: boolean;
  isDeleted?: boolean;
}> = ({iconName, text, iconOnly = false, isDeleted = false}) => (
  <TailwindContents>
    <div className="flex items-center">
      <div
        className="mr-4 flex h-[22px] w-[22px] flex-[0_0_22px] items-center justify-center rounded-[16px]"
        style={{backgroundColor: hexToRGB(MOON_300, 0.48)}}>
        <Icon name={iconName} width={14} height={14} />
      </div>
      {!iconOnly && (
        <div
          className={clsx(
            'h-[22px] min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap',
            isDeleted ? 'line-through' : 'no-underline'
          )}>
          {text}
        </div>
      )}
    </div>
  </TailwindContents>
);
